export default function isUserSearchParamsEmpty(user): boolean {
  // return Object.keys(user!.pipelinesSearchParams || {}).length === 0
  if (!user?.pipelinesSearchParams) {
    return true
  }

  const { option, text } = user?.pipelinesSearchParams

  return !option && !text
}
